import React, { useState } from "react";
import RCSCarouselPage from "./RCSCarousel";

const tabs = [
  { id: "CAROUSEL", label: "Send Message" },
  { id: "CAROUSEL_ADVANCED", label: "Suggested Reply" },
];

const RCSCarousel = () => {
  const [activeTab, setActiveTab] = useState("CAROUSEL");

  const wrapperStyle = {
    borderBottom: "1px solid #e4e4e4",
    backgroundColor: "#f3f4f6",
    paddingLeft: "16px",
    paddingTop: "10px",
  };

  const tabStyle = {
    padding: "8px 20px",
    border: "none",
    outline: "none",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    backgroundColor: "#ffffff",
    color: "#000",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "0px",
    position: "relative",
    top: "1px",
    zIndex: 1,
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: "#00bcd4",
    color: "#fff",
    zIndex: 2,
  };

  return (
    <div>
      <div style={wrapperStyle}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              style={activeTab === tab.id ? activeTabStyle : tabStyle}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: "16px" }}>
        <RCSCarouselPage activeTab={activeTab} />
      </div>
    </div>
  );
};

export default RCSCarousel;
